import * as React from "react";
import Image from 'next/image'
import Button from "@mui/material/Button";
import NextLink from "next/link";
import clsx from "clsx";

export default function LandingSubSection1(props){
    return(
        <section id={'info'} className={'flex flex-col w-full mt-15 sm:mt-28 justify-center items-center'}>
            {!props.screenMobile && (
                <div className={'flex max-w-300 w-full py-12 pl-5 laptop-xl:pl-0 text-normal'}>
                    <nav>
                        <ul className={'flex flex-row'}>
                            <li>
                                <NextLink href={'/'} className={'text-black-1 hover:text-red-1'}>Главная</NextLink>
                            </li>
                            <li>
                                <span className={'px-1.5'}>&gt;</span>
                                <NextLink href={props.breadcrumbLink} className={'text-black-1 hover:text-red-1'}>{props.breadcrumbRoot}</NextLink>
                            </li>
                            <li className={'text-red-1'}>
                                <span className={'px-1.5'}>&gt;</span>
                                {props.breadcrumbCurrent}
                            </li>
                        </ul>
                    </nav>
                </div>
            )}
            {props.screenMobile ? (
                <>
                    <div className={clsx('flex w-full justify-end items-end', props.imageBackground ? props.imageBackground : 'bg-gradient-to-r from-red-2 to-red-3')}>
                        <Image
                            src={props.imageMobile}
                            alt="Логотип CLapps"
                            quality={100}
                            sizes="100vw"
                            style={{
                                height: '206px',
                            }}
                        />
                    </div>
                    <h1 itemProp="name" className={'w-full max-w-192 mt-6 px-5 text-22px sm:text-46px text-black-1 font-black leading-relaxed sm:leading-snug'}>
                        {props.title}
                    </h1>
                </>
            ) : (
                <div className={clsx('flex w-full justify-center items-center', props.imageBackground ? props.imageBackground : 'bg-gradient-to-r from-red-2 to-red-3')}>
                    <div className={'relative flex max-w-300 w-full h-[15.25rem] items-center'}>
                        <h1 itemProp="name" className={clsx('z-10 max-w-192 pl-5 laptop-xl:pl-0 text-3xl sm:text-46px font-black leading-snug', props.titleColor ? props.titleColor : 'text-white')}>
                            {props.title}
                        </h1>
                        <div className={'absolute bottom-[-3px] right-0'}>
                            <Image
                                src={props.image}
                                alt="Логотип CLapps"
                                quality={100}
                                sizes="100vw"
                                style={{
                                    height: '100%',
                                }}
                            />
                        </div>
                    </div>
                </div>
            )}
            <div className={'flex flex-col max-w-300 px-5 laptop-xl:px-0 justify-start'}>
                <p itemProp="description" className={'w-full mt-6 sm:mt-14 text-sm sm:text-22px text-black-2 leading-loose sm:leading-relaxed'}>
                    {props.textA}
                </p>
                {props.textB && (
                    <p className={'w-full mt-6 sm:mt-12 text-sm sm:text-22px text-black-2 leading-loose sm:leading-relaxed'}>
                        {props.textB}
                    </p>
                )}
                <Button className={'sm:max-w-72 w-full h-14 sm:h-16 mt-6 sm:mt-14 btn-color-filled'} onClick={props.handleOpenModal}>
                    Отправить заявку
                </Button>
            </div>
        </section>
    )
}